import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
  // import { apiConstant } from '../../config/apiconfig.const';
    @Injectable({
        providedIn: 'root'
      })
      export class CommonfileService {
        loading: number = 0;
        constructor(
          private _http: HttpClient,
        ) { } 
              public data = {};
              setData(key: any, data: any) {
                this.data[key] = data;
              }
              getData(key: any) {
                return this.data[key];
              }
  }